
// export const myGetter = ( state ) => {
//   return
// }

export const getUsers = ( state ) => {
    return state.users
}

export const getPrograms = ( state ) => {
    return state.programs
}

export const getHfs = ( state ) => {
    return state.hfs
}

export const getCurrentUser = ( state ) => {
    return state.currentUser
}

export const getTeachers = ( state ) => {
    return state.teachers
}

export const getUsersStatistics = ( state ) => {
    return state.usersStaticts
}